import { FC, memo } from 'react';
import { Menu, theme, Button } from 'native-base';
import { getIcon } from '../helpers/icon.helper';
import { ItemMode } from '../models/Item.class';
import { ItemsModeSortOptions } from '../views/protected/views/Home';

interface FilterByModeProps {
  itemsFilterMode: ItemMode | 'all',
  setItemsFilterMode: React.Dispatch<React.SetStateAction<ItemMode | "all">>,
  filterModeOptions: ItemsModeSortOptions
}

const FilterByMode: FC<FilterByModeProps> = ({itemsFilterMode, filterModeOptions, setItemsFilterMode}) => {
  return (
    <Menu
      width='150'
      placement='left'
      trigger={triggeProps => (
        <Button
          size='sm'
          borderWidth={1}
          borderColor={theme.colors.coolGray[200]}
          _text={{
            color: theme.colors.coolGray[600]
          }}
          variant='unstyled'
          rounded='full'
          leftIcon={
            getIcon('mi/filter-list', {size: 18, color: theme.colors.primary[800]})!
          }
          rightIcon={
            getIcon('sli/arrow-down', {size: 12, color: theme.colors.primary[800]})!
          }
          {...triggeProps}
        >
          {filterModeOptions[itemsFilterMode]}
        </Button>
      )}
    >
      {Object.keys(filterModeOptions).map(sortType => (
        <Menu.Item key={sortType} _text={{fontSize: 'xs'}} onPress={() => setItemsFilterMode(sortType as ItemMode)}>
          {filterModeOptions[sortType as keyof ItemsModeSortOptions]}
        </Menu.Item>
      ))}
    </Menu>
  );
}

export default memo(FilterByMode);
